export const FoldType = {
  Size105: 105,
  Size87: 87
}
